import React, { useContext } from 'react';
import { Link, navigate } from 'raviger';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserCircle
} from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from "../accounts/AccountsReducer";

function Header({...props}) {

  const { state } = useContext(AuthContext);
  const path = window.location.pathname;
  const org_slug = path.split('/')[1];
  const incident_slug = path.split('/')[2];

  return (
    <Row className="mt-2" style={{marginBottom:"-15px"}}>
      <Col xs={12} className="d-flex">
        <h1 className="w-100">
          {props.children}
          {state && state.user.id && !path.includes('/accounts/') && !path.includes('/manage/') ? <OverlayTrigger
            key={"user-profile"}
            placement="left"
            overlay={
              <Tooltip id={`tooltip-user-profile`}>
                {state.user.first_name} {state.user.last_name} User Profile
              </Tooltip>
            }
          >
            <Link className="float-right" href={"/" + org_slug + "/" + incident_slug + "/accounts/userprofile/" + state.user.id} style={{textDecoration:"none", color:"white"}}><FontAwesomeIcon icon={faUserCircle} className="ml-3 mt-2 fa-move-up float-right" /></Link>
          </OverlayTrigger> : ""}
          {props.version ? <span className="float-right">{props.version}</span> : ""}
        </h1>
      </Col>
    </Row>
  )
}

export default Header;
